<template>
  <!-- begin widget-chat -->
  <div v-if="job" class="widget-chat rounded mt-3">
    <ImageModal />
    <!-- begin widget-chat-header -->
    <!-- begin widget-chat-body -->
    <div class="widget-chat-body" data-scrollbar="true" data-height="235px">
      <!--<div class="text-center text-gray-500 m-3 fw-bold">Today</div>-->
      <div class="widget-chat-item with-media" :class="item.user.id == user.id ? 'end' : 'start'"
        v-for="(item, index) in job.messages" :key="index">
        <div class="widget-chat-media">
          <img onerror="javascript:this.src='/images/avatar/user.png'" alt=""
            :src="`/images/avatar/` + item.user.avatar" />
        </div>
        <div class="widget-chat-info">
          <div class="widget-chat-info-container">
            <div class="widget-chat-name text-indigo">{{ item.user.name }}</div>
            <div class="widget-chat-message pre-formatted">
              <div v-html="addTagsToLinks(item.message)"></div>
              <div class="d-flex flex-wrap">
                <div class="m-2" v-for="(image, index) in item.images" :key="index">
                  <!-- BEGIN image -->
                  <img class="imageWrapper" :src="`/images/screen/` + image.name" alt=""
                    @click="open(`/images/screen/` + image.name)" />
                  <!-- END image -->
                </div>
              </div>
            </div>
            <div class="widget-chat-time">{{ item.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end widget-chat-body -->



    <!-- BEGIN nav-tabs-pills -->
    <div class="mb-1 mt-3">
      <b-tabs pills nav-class="mb-1 mt-1" content-class="panel mb-0 p-0 rounded-0 rounded-top">
        <b-tab active>
          <template slot="title">
            <span class="d-sm-none small">Принять</span>
            <span class="d-sm-block d-none">Принять</span>
          </template>
          <div class="mt-2">
            <textarea v-model="message" class="form-control" rows="6"
              placeholder="Здесь Вы можете написать ответ исполнителю, поблагодарить его за проделанную работу"></textarea>
            <small v-show="!error_message" class="text-gray-500">Добавить скриншот</small>
            <small class="text-danger">{{ error_message }}</small>
            <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
            <div class="d-flex justify-content-between">
              <div class="btn btn-default" @click="chooseFiles()">
                <i class="fas fa-cloud-arrow-up"></i> Скриншот
              </div>
              <div class="btn btn-primary w-120" @click="$bvModal.show('modalDialog')">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Принять</span>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="d-sm-none small">Доработать</span>
            <span class="d-sm-block d-none">Доработать</span>
          </template>
          <div class="mt-2">
            <textarea v-model="message" class="form-control" rows="6"
              placeholder="Опишите подробно что необходимо доработать"></textarea>
            <small v-show="!error_message" class="text-gray-500">Что необходимо доработать</small>
            <small class="text-danger">{{ error_message }}</small>
            <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
            <div class="d-flex justify-content-between">
              <div class="btn btn-default" @click="chooseFiles()">
                <i class="fas fa-cloud-arrow-up"></i> Скриншот
              </div>
              <div class="btn btn-info w-120" @click="declined()">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Отправить</span>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="d-sm-none small">Отказать</span>
            <span class="d-sm-block d-none">Отказать</span>
          </template>

          <div class="mt-2">
            <textarea v-model="message" class="form-control" rows="6" placeholder="Опишите причину отказа"></textarea>
            <small v-show="!error_message" class="text-gray-500">Причина отказа</small>
            <small class="text-danger">{{ error_message }}</small>
            <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
            <div class="d-flex justify-content-between">
              <div class="btn btn-default" @click="chooseFiles()">
                <i class="fas fa-cloud-arrow-up"></i> Скриншот
              </div>
              <div class="btn bg-orange-400 text-white w-120" @click="cancel()">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Отказать</span>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="d-sm-none small">Арбитраж</span>
            <span class="d-sm-block d-none">Арбитраж</span>
          </template>
          <div class="mt-2">
            <textarea v-model="message" class="form-control" rows="6"
              placeholder="Обращение в арбитраж это крайняя мера в решении проблемы с заданием. Пожалуйста, попробуйте разрешить ситуацию с заказчиком самостоятельно, напишите комментарий к заданию. Если у вас появились разногласия в ходе проверки задания, наши админы помогут вам их разрешить."></textarea>

            <small v-show="!error_message" class="text-gray-500">Опишите подробно
              претензию</small>
            <small class="text-danger">{{ error_message }}</small>
            <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
            <div class="d-flex justify-content-between">
              <div class="btn btn-default" @click="chooseFiles()">
                <i class="fas fa-cloud-arrow-up"></i> Скриншот
              </div>
              <div class="btn btn-danger w-110" @click="arbitrage()">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Арбитраж</span>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <input @change="pickFile" id="fileUpload" ref="fileInput" type="file" style="display: none" />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <hr />
    <!-- END nav-tabs-pills -->
    <!-- BEGIN #modal-dialog -->
    <b-modal id="modalDialog" cancel-variant="default" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Подтверждение:</h4>
        <a class="btn-close" @click="$bvModal.hide('modalDialog')"></a>
      </template>
      <p class="text-center pt-3">Вы уверены что хотите приять и оплатить это задание ?</p>
      <template #modal-footer>
        <div>
          <b-button variant="white" size="sm" class="float-right me-2" @click="$bvModal.hide('modalDialog')">
            Отмена
          </b-button>
          <b-button variant="primary" size="sm" class="float-right" @click="accept() || $bvModal.hide('modalDialog')">
            Принять и оплатить
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END #modal-dialog -->
  </div>
  <!-- end widget-chat -->
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";
import axios from "axios";

export default {
  name: "TaskChat",
  props: ["job", "task"],
  data() {
    return {
      loading: false,
      message: "",
      status: "REVIEW",
      previewImage: null,
      images: [],
      files: [],
      user: {},
      error_message: "",
    };
  },

  mounted() {
    console.log("job", this.job);
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    isUrlValid(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    stringToUrl(str) {
      return this.isUrlValid(str) ? `<a target="_blank" href="${str}">${str}</a>` : str
    },
    addTagsToLinks(str) {
      str = str.replace(/(<([^>]+)>)/ig, '')
      let lines = str.split(/\r?\n/)
      lines = lines.map(x => x.split(' ').reduce((accumulator, currentValue) => accumulator + ' ' + this.stringToUrl(currentValue), ''))

      return lines.reduce((accumulator, currentValue) => accumulator + '\r\n' + this.stringToUrl(currentValue))
    },
    tabClick() {
      this.error_message = '';
    },
    arbitrage() {
      if (!this.message) {
        this.error_message = "Опишите подробно суть претензии";
        return;
      }
      this.jobUpdate("ARBITRAGE");
    },
    cancel() {
      if (!this.message) {
        this.message = "В выплате отказано";
      }
      this.jobUpdate("REJECTED");
    },
    declined() {
      if (!this.message) {
        this.error_message = "Напишите что нужно доработать";
        return;
      }
      this.jobUpdate("DECLINED");
    },
    accept() {
      if (!this.message) {
        this.message = 'Задание принято. '
      }
      this.jobUpdate("ACCEPTED");
    },

    open(img) {
      window.eventBus.$emit("image.show", img);
    },
    chooseFiles() {
      //document.getElementById("fileUpload").click();
      this.$router.push('/howtoscreen')
    },
    previewFiles(event) {
      console.log(event.target.files);
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      console.log("pickFile");
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        this.files.push(file[0]);
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
          this.images.push(e.target.result);
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
    async saveImages(message_id) {
      this.loading = true;
      this.$insProgress.start();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };

      for (let i = 0; i < this.files.length; i++) {
        const data = new FormData();
        data.append("avatar", this.files[i]);
        data.append("message_id", message_id);
        await axios
          .post("/api/image", data, config)
          .then((response) => {
            console.log("response", response);
          })
          .catch((error) => {
            show_error(this.$notify, null, error.response.data);
          })
          .finally(() => {
            console.log("finally");
          });
      }
      this.images = [];
      this.files = [];
      this.$insProgress.finish();
    },

    jobUpdate(status) {
      this.error_message = ''
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put(`/job/${this.job.id}`, {status, message: this.message})
        .then(async (resp) => {
          await this.saveImages(resp.data.id);
          this.message = "";
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
          window.eventBus.$emit("customer.chat.update");
        });
    },
  },
};
</script>

<style>
.imageWrapper {
  width: 150px;
  height: 150px;
  display: block;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

@media (max-width: 576px) {
  .hide-576 {
    display: none;
  }
}

.w-120 {
  width: 120px !important;
}

@media (max-width: 576px) {
  .nav-link {
    padding: 0.3rem 0.5rem !important;
  }
}
</style>
